interface MembershipState {
  active: boolean;
  inactivate_at?: string;
}

// Ticket claim enforcement only processes members that are active and have no
// inactivate_at, including one that is still in the future.
export const receivesScheduledTickets = (membership: MembershipState) =>
  membership.active && !membership.inactivate_at;

export const scheduledClaimCount = (
  activeClaimCount: number,
  recordedStateCount: number,
  membership: MembershipState,
) => {
  if (!receivesScheduledTickets(membership)) return 0;
  return Math.max(0, activeClaimCount - recordedStateCount);
};
